import {Component, Input, OnInit} from "@angular/core";
import {NgClass, NgStyle} from "@angular/common";

@Component({
    selector: 'db-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgStyle
    ]
})
export class LoadingBarComponent implements OnInit {

  @Input() loading: boolean;
  @Input() progressPercent: number;
  @Input() simulation: boolean;
  @Input() height: number;
  @Input() state: 'info'|'success'|'warning'|'danger'|'global';

  ngOnInit() {
    if (!this.height) {
      this.height = 2;
    }

    if (!this.state) {
      this.state = 'info';
    }
  }

}
